import { getAllAccountsRequest } from 'actions/accountActions';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

/**
 * Checks if all accounts are populated in the redux store for the currently assigned grandparent.
 * If not, it dispatches a request to get all the accounts.
 */
export const useCheckGetAllAccountsRequest = ({ enabled = true } = {}) => {
  const dispatch = useDispatch();
  const allAccountsTotalSize = useSelector((state) => state.accountsStore.allAccountsTotalSize);
  const allAccountsLoading = useSelector((state) => state.accountsStore.isAllAccountsLoading);
  const allAccountsError = useSelector((state) => state.accountsStore.isAllAccountsError);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);
  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);

  useEffect(() => {
    if (!enabled) return;
    if (!allAccountsLoading && (allAccountsTotalSize === 0 || allAccountsError)) {
      dispatch(getAllAccountsRequest(assignedAccountNumber, assignedGrandfatherClientNumber));
    }
  }, []);
};
